export default "__VITE_ASSET__CKLExg5s__"